// The values of a section's fields put into the left column (um/2026-10-30/03 п.7): each field a folder on a branch, its values
// (and their children, for a tree) as items without icons; a click narrows the list to the value, a click on the lit one widens it back.

import type { FieldDef, TermDef } from '@confdeck/core-shared';
import { useMeta } from '../sync/react.tsx';
import { navigate, useLocation } from './router.ts';
import { Branches, NavRow, useFolder } from './SideNav.tsx';
import { listHref, navTerms } from './nav-terms.ts';
import s from './shell.module.css';

export function NavTermFolder({ typeKey, field, lit }: { typeKey: string; field: FieldDef; lit: string | undefined }) {
  const meta = useMeta();
  const [open, flip] = useFolder(`navfield:${field.id}`);
  return (
    <div className={s.navNode}>
      <NavRow icon="tag" label={field.name} onClick={flip} toggle={{ open, onToggle: flip, label: field.name }} />
      {open && <Branches>{navTerms(meta, field).map((t) => <TermItem key={t.id} typeKey={typeKey} term={t} lit={lit} />)}</Branches>}
    </div>
  );
}

function TermItem({ typeKey, term, lit }: { typeKey: string; term: TermDef; lit: string | undefined }) {
  const meta = useMeta();
  const kids = meta.children(term.id, term.taxonomyId);
  const [open, flip] = useFolder(`navterm:${term.id}`, true);
  const label = <><span className={s.termDot} style={{ background: `var(--c-${term.color}-dot)` }} />{term.name}</>;
  // The open view stays; a click on the lit value takes it off (um/2026-10-30/03 п.7, MiniMax review wave 2).
  const view = useLocation().search.get('view');
  const go = () => navigate(listHref(typeKey, view, lit === term.id ? null : term.id));
  if (!kids.length) return <NavRow label={label} on={lit === term.id} onClick={go} />;
  return (
    <div className={s.navNode}>
      <NavRow label={label} on={lit === term.id} onClick={go} toggle={{ open, onToggle: flip, label: term.name }} />
      {open && <Branches>{kids.map((k) => <TermItem key={k.id} typeKey={typeKey} term={k} lit={lit} />)}</Branches>}
    </div>
  );
}
